var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m15.66 29.29 15.39-15.4-4.94-5-15.4 15.4L9 31.06l6.71-1.77Zm-.7-.71L11.42 25l12.09-12 3.54 3.54Zm14.68-14.69-1.88 1.89-3.54-3.54 1.89-1.88ZM10.35 29.65l.89-3.37 2.48 2.48Z"
})));
export default SvgEdit;